/**
 * Description: Filter Component containing common filter options (ex. some date range, outfit source)
 */
import React from 'react';
import {
  Select,
  DatePicker
} from 'AWS-UI-Components-React';
import Moment from 'moment';
import '../styles/filterSection.css';
import {AuditButton} from './auditButton';
import { ErrorMessage } from './filterErrorSection.jsx';
import { MARKETPLACES }from './constants';

const OUTFIT_SOURCES = [
  {
    "label": "Any Source",
    "id": "default"
  },
  {
    "label": "Lab126 Algorithm",
    "id": "Lab126 Algorithm"
  },
  {
    "label": "Detail Page - Control",
    "id": "default_control"
  },
  {
    "label": "Detail Page - Boosting1",
    "id": "default_boosting1"
  },
  {
    "label": "Detail Page - Boosting2",
    "id": "default_boosting2"
  },
  {
    "label": "Detail Page - MultiComp",
    "id": "default_multicomp"
  },
  {
    "label": "Detail Page - OBModelV3",
    "id": "default_obmodelv3"
  },
  {
    "label": "Detail Page - Occasion",
    "id": "default_occasion"
  },
  {
    "label": "Try Before You Buy - Control",
    "id": "tbyb_control"
  },
  {
    "label": "Premium Brands - Control",
    "id": "premiumbrands_control"
  },
  {
    "label": "The Drop - Control",
    "id": "thedrop_control"
  },
  {
    "label": "Shop Bop - Control",
    "id": "shopbop_control"
  },
  {
    "label": "Zappos - Control",
    "id": "zappos_control"
  },
  {
    "label": "Fashion Science Algorithm",
    "id": "Fashion Science Algorithm"
  },
  {
    "label": "Visual Similarities Pipeline",
    "id": "Visual Similarities Pipeline"
  },
  {
    "label": "Fashion Specialist",
    "id": "Fashion Specialist"
  },
  {
    "label": "Test",
    "id": "Test"
  }
];

const SEED_CATEGORIES = [
  {
    "label": "Any Category",
    "id": "default"
  },
  {
    "label": "Bracelet",
    "id": "Bracelet"
  },
  {
    "label": "Dress",
    "id": "Dress"
  },
  {
    "label": "Earrings",
    "id": "Earrings"
  },
  {
    "label": "Handbag/Wallet",
    "id": "Handbag/Wallet"
  },
  {
    "label": "Men's Belt",
    "id": "Men's Belt"
  },
  {
    "label": "Men's Bottom",
    "id": "Men's Bottom"
  },
  {
    "label": "Men's Jacket",
    "id": "Men's Jacket"
  },
  {
    "label": "Men's Shoes",
    "id": "Men's Shoes"
  },
  {
    "label": "Men's Sunglasses",
    "id": "Men's Sunglasses"
  },
  {
    "label": "Men's Top",
    "id": "Men's Top"
  },
  {
    "label": "Men's Wallet",
    "id": "Men's Wallet"
  },
  {
    "label": "Men's Watch",
    "id": "Men's Watch"
  },
  {
    "label": "Necklace",
    "id": "Necklace"
  },
  {
    "label": "Women's Bottom",
    "id": "Women's Bottom"
  },
  {
    "label": "Women's Jacket",
    "id": "Women's Jacket"
  },
  {
    "label": "Women's Shoes",
    "id": "Women's Shoes"
  },
  {
    "label": "Women's Sunglasses",
    "id": "Women's Sunglasses"
  },
  {
    "label": "Women's Top",
    "id": "Women's Top"
  },
  {
    "label": "Women's Watch",
    "id": "Women's Watch"
  },
  {
    "label": "Women's Cardigans",
    "id": "Women's Cardigans"
  },
  {
    "label": "Women's Shrugs/Vests",
    "id": "Women's Shrugs/Vests"
  },
  {
    "label": "IN Sarees",
    "id": "IN Sarees"
  },
  {
    "label": "IN Kurta/Kurties",
    "id": "IN Kurta/Kurties"
  },
  {
    "label": "IN Lehenga Cholis",
    "id": "IN Lehenga Cholis"
  },
  {
    "label": "IN Earrings",
    "id": "IN Earrings"
  },
  {
    "label": "IN Jewelry Sets",
    "id": "IN Jewelry Sets"
  }
]

const AFTER_DATE_FORMAT = "YYYY-MM-DDT00:00:00.000ZZ";
const BEFORE_DATE_FORMAT = "YYYY-MM-DDT23:59:59.999ZZ";

export class FilterCommon extends React.Component {
  constructor(props) {
    super(props);
    this.errorMessage = React.createRef();
    this.state = {
      filter_options: {
        outfit_source: "",
        after_date: "",
        before_date: "",
        marketplace: "0",
        seed_category: ""
      }
    };
    this.filter_labels = this.props.filter_labels;
    this.handleFilterButtonClick = this.handleFilterButtonClick.bind(this);
  }

  handleFilterButtonClick() {
    // check filter options first
    if (this.errorMessage.current.checkFilterOptions(this.state.filter_options).length > 0) {
      return null;
    }

    // modify filter options format
    var formatted_filters = {
        after_date: this.state.filter_options.after_date,
        before_date: this.state.filter_options.before_date,
        outfit_source: "",
        marketplace: this.state.filter_options.marketplace,
        seed_category: ""
    };
    if (this.state.filter_options.after_date.length > 0) {
      formatted_filters.after_date = Moment(this.state.filter_options.after_date).format(AFTER_DATE_FORMAT);
    }
    if (this.state.filter_options.before_date.length > 0) {
      formatted_filters.before_date = Moment(this.state.filter_options.before_date).format(BEFORE_DATE_FORMAT);
    }
    if (this.state.filter_options.outfit_source != "default") {
      formatted_filters.outfit_source = this.state.filter_options.outfit_source;
    }
    if (this.state.filter_options.seed_category != "default") {
      formatted_filters.seed_category = this.state.filter_options.seed_category;
    }
    return this.props.filterCallback(formatted_filters);
  }

  render() {
    const FilterContent = () => (
      <div>
        <div><ErrorMessage ref={this.errorMessage}/></div>

        <div>{this.filter_labels.after_date}</div>            
        <div><DatePicker
          todayLabel="Today"
          nextMonthLabel="Next month"
          previousMonthLabel="Previous month"
          value={this.state.filter_options.after_date}
          placeholder="YYYY/MM/DD"
          onChange={ (event) => {
            this.state.filter_options.after_date = event.detail.value;
            }
          }
        >
        </DatePicker></div>

        <div>{this.filter_labels.before_date}</div>              
        <div><DatePicker
          todayLabel="Today"
          nextMonthLabel="Next month"
          previousMonthLabel="Previous month"
          value={this.state.filter_options.before_date}
          placeholder="YYYY/MM/DD"
          onChange={ (event) => {
            this.state.filter_options.before_date = event.detail.value;
          }
        }
        >
        </DatePicker></div>
        
        <div>Outfit Source:</div>
        <div><Select 
          options={OUTFIT_SOURCES}
          enableFiltering={true}
          empty="No options"
          selectedId={this.state.filter_options.outfit_source}
          placeholder="Any Source"
          onChange={ (event) => {
            this.state.filter_options.outfit_source = event.detail.selectedId;
          }
        }
        ></Select></div>
        
        <div>Marketplace:</div>
        <div><Select
          options={MARKETPLACES}
          enableFiltering={true}
          empty="No options"
          selectedId={this.state.filter_options.marketplace}
          placeholder="Select a marketplace"
          onChange={ (event) => {
            this.state.filter_options.marketplace = event.detail.selectedId;
          }
        }
        ></Select></div>

        <div>Seed Category:</div>
        <div><Select
          options={SEED_CATEGORIES}
          enableFiltering={true}
          empty="No options"
          selectedId={this.state.filter_options.seed_category}
          placeholder="Select a seed category"
          onChange={ (event) => {
            this.state.filter_options.seed_category = event.detail.selectedId;
          }
        }
        ></Select></div>

        <div><AuditButton
          text={this.filter_labels.button_text}
          handler={this.handleFilterButtonClick.bind(this)}
        /></div>
      </div>
    );
              

    return (
      <div className="awsui">
        <div>
          <FilterContent/>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/filterSection.jsx